"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerError = exports.PbError = void 0;
/** Generic Owner error */
var PbError = /** @class */ (function (_super) {
    __extends(PbError, _super);
    /**
     * Throws a PbError
     *
     * @param message The error message
     * @param context Error payload
     * @param opts Error options
     * @param opts.override Set to true if you want to catch other PbErrors
     */
    function PbError(message, context, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.override, override = _c === void 0 ? false : _c;
        var _this = _super.call(this, message) || this;
        _this.isPbError = true;
        _this.name = 'PbError';
        if (!override && (context === null || context === void 0 ? void 0 : context.isPbError))
            throw context;
        _this.context = context;
        // This method is only available in NodeJS
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, PbError);
        }
        return _this;
    }
    return PbError;
}(Error));
exports.PbError = PbError;
/** Any error originating server-side */
var ServerError = /** @class */ (function (_super) {
    __extends(ServerError, _super);
    /**
     *
     * @param status An HTTP status code
     * @param message The message for the
     * @param context deprecated: error context (use opts.details instead)
     * @param opts An options object
     * @param opts.displayToClient Set to true if the server-originated error should be displayed to the client
     * @param opts.details Typed error details
     * @param opts.override Set to true if you want to catch PbErrors
     */
    function ServerError(status, message, context, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.displayToClient, displayToClient = _c === void 0 ? false : _c, _d = _b.override, override = _d === void 0 ? false : _d, _e = _b.details, details = _e === void 0 ? null : _e;
        var _this = _super.call(this, message, context, { override: override }) || this;
        _this.displayToClient = false;
        _this.name = 'ServerError';
        _this.status = 500;
        _this.details = null;
        _this.status = status;
        _this.details = details;
        _this.displayToClient = displayToClient;
        return _this;
    }
    return ServerError;
}(PbError));
exports.ServerError = ServerError;
//# sourceMappingURL=index.js.map